import { Flex, Icon, Text } from "@chakra-ui/react";
import BedIcon from "assets/icons/medium/bed.svg?react";
import FileIcon from "assets/icons/medium/file.svg?react";
import type { TenancyAgreementSummaryData } from "modules/landlord-portal/models/overview";

type PropertyCountNumbersProps = {
  propertySummary?: TenancyAgreementSummaryData;
};

export function PropertyCountNumbers({
  propertySummary,
}: PropertyCountNumbersProps) {
  return (
    <Flex direction={["column", "row"]} gap={[2, 4]}>
      <Flex direction={"row"} align={"center"} gap={1.5}>
        <Icon as={FileIcon} />

        <Text fontSize={"md"} fontWeight={600}>
          {propertySummary?.total}
          {" agreement/s"}
        </Text>
      </Flex>
      <Flex direction={"row"} align={"center"} gap={1.5}>
        <Icon as={BedIcon} />

        <Text fontSize={"md"} fontWeight={600}>
          {propertySummary?.occupied} occupied
        </Text>
      </Flex>
      <Flex direction={"row"} align={"center"} gap={1.5}>
        <Icon as={BedIcon} />

        <Text fontSize={"md"} fontWeight={600}>
          {propertySummary?.vacant} vacant
        </Text>
      </Flex>
    </Flex>
  );
}
